import { Component, effect, inject, input, linkedSignal, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { lucidePen, lucidePlus } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmCardImports } from '@spartan-ng/helm/card';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { HlmLabelImports } from '@spartan-ng/helm/label';
import { HlmSwitchImports } from '@spartan-ng/helm/switch';
import { HlmTableImports } from '@spartan-ng/helm/table';
import { toast } from 'ngx-sonner';

import { PaginateurComponent } from '@shared/components/paginateur/paginateur.component';
import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';
import { Cartographie } from '../../../cartographie/models/cartographie.model';
import { ParcoursStore } from '../../../référentiel-métier-parcours/store/parcours.store';
import { Parcours } from '../../../référentiel-métier-parcours/models/parcours.model';
import { ParcoursFormComponent } from '../form/référentiel-form.component';

@Component({
  selector: 'app-referentiels-list',
  imports: [
    HlmIconImports,
    HlmButtonImports,
    RouterModule,
    PaginateurComponent,
    FormsModule,
    HlmSwitchImports,
    HlmCardImports,
    HlmTableImports,
    HlmLabelImports,
    HlmTooltipImports,
  ],
  providers: [provideIcons({ lucidePlus, lucidePen })],
  templateUrl: './parcours-list.component.html',
})
export class ParcoursListComponent implements OnDestroy {
  readonly parcoursStore = inject(ParcoursStore);
  readonly #sidepanelService = inject(SidepanelService);

  readonly cartographie = input.required<Cartographie>();

  readonly parcoursAll = linkedSignal(() =>
    this.parcoursStore.getPaginated().sort((p1, p2) => p1.referentiel!.nom.localeCompare(p2.referentiel!.nom)),
  );

  constructor() {
    effect(() => this.parcoursStore.chargerParCartographie(this.cartographie().id));
  }

  ngOnDestroy(): void {
    toast.dismiss();
  }

  editerParcours(parcours: Parcours) {
    this.#sidepanelService.setComponentToDisplay(
      'Éditer le parcours',
      ParcoursFormComponent,
      `Modifier le nom du parcours.`,
      {
        parcours,
        cartographie: this.cartographie(),
      },
    );
    this.#sidepanelService.open();
  }
}
